import { Link } from 'react-router-dom'
import { useTenant } from '../hooks/useTenant'

export function SettingsPage() {
  const { profile } = useTenant()

  return (
    <div className="max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-8">
        Settings
      </h1>

      <div className="space-y-4">
        {/* Organization Settings - only for admins */}
        {profile?.role === 'org_admin' && (
          <Link
            to="/settings/organization"
            className="block bg-white dark:bg-gray-800 rounded-lg shadow p-6 hover:shadow-md transition-shadow"
          >
            <div className="flex items-center">
              <span className="text-3xl mr-4">🏢</span>
              <div className="flex-1">
                <h2 className="text-lg font-semibold text-gray-900 dark:text-white">
                  Organization Settings
                </h2>
                <p className="text-sm text-gray-500 dark:text-gray-400">
                  Manage organization name, contact info, and configuration
                </p>
              </div>
              <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </div>
          </Link>
        )}

        {/* Team Members - placeholder */}
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6 opacity-60">
          <div className="flex items-center">
            <span className="text-3xl mr-4">👥</span>
            <div className="flex-1">
              <h2 className="text-lg font-semibold text-gray-900 dark:text-white">
                Team Members
              </h2>
              <p className="text-sm text-gray-500 dark:text-gray-400">
                Invite and manage team members — Coming soon
              </p>
            </div>
            <span className="text-xs bg-gray-200 dark:bg-gray-700 text-gray-600 dark:text-gray-400 px-2 py-1 rounded">
              Coming Soon
            </span>
          </div>
        </div>

        {/* Notifications - placeholder */}
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6 opacity-60">
          <div className="flex items-center">
            <span className="text-3xl mr-4">🔔</span>
            <div className="flex-1">
              <h2 className="text-lg font-semibold text-gray-900 dark:text-white">
                Notifications
              </h2>
              <p className="text-sm text-gray-500 dark:text-gray-400">
                Configure email and in-app notifications — Coming soon
              </p>
            </div>
            <span className="text-xs bg-gray-200 dark:bg-gray-700 text-gray-600 dark:text-gray-400 px-2 py-1 rounded">
              Coming Soon
            </span>
          </div>
        </div>

        {/* Account - placeholder */}
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6 opacity-60">
          <div className="flex items-center">
            <span className="text-3xl mr-4">👤</span>
            <div className="flex-1">
              <h2 className="text-lg font-semibold text-gray-900 dark:text-white">
                Account
              </h2>
              <p className="text-sm text-gray-500 dark:text-gray-400">
                Manage your profile and preferences — Coming soon
              </p>
            </div>
            <span className="text-xs bg-gray-200 dark:bg-gray-700 text-gray-600 dark:text-gray-400 px-2 py-1 rounded">
              Coming Soon
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}
